import * as types from '../actions';

const initialState = {
    filterFeedbackErrorData:'',
    filterFeedbackActivity:'',
    filterFeedbackStatus:'',
    filterFeedbackEventsList: [],
    filterFeedbackReviewersList: [],
    filterChiefReviewersList:[] 
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.FEEDBACK_FILTER_EVENTS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,      
                    filterFeedbackEventsList:response.data,         
                    filterFeedbackStatus: response.status,  
                    filterFeedbackActivity:types.FEEDBACK_FILTER_EVENTS_LIST_SUCCESS+timeVar, 
                };
            }else{
                return {
                    ...state,               
                    filterFeedbackStatus: response.status,  
                    filterFeedbackActivity:types.FEEDBACK_FILTER_EVENTS_LIST_ERROR+timeVar, 
                    filterFeedbackErrorData:response.data                              
                };
            }
        case types.FEEDBACK_FILTER_EVENTS_LIST_ERROR:
            return {
                ...state,               
                filterFeedbackStatus: response.status,  
                filterFeedbackActivity:types.FEEDBACK_FILTER_EVENTS_LIST_ERROR+timeVar, 
                filterFeedbackErrorData:response.data                              
            };
                
        
        case types.FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,      
                    filterFeedbackReviewersList:response.data,         
                    filterFeedbackStatus: response.status,  
                    filterFeedbackActivity:types.FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS+timeVar, 
                };
            }else{
                return {
                    ...state,               
                    filterFeedbackStatus: response.status,  
                    filterFeedbackActivity:types.FEEDBACK_FILTER_REVIEWERS_LIST_ERROR+timeVar, 
                    filterFeedbackErrorData:response.data                              
                };
            }
        case types.FEEDBACK_FILTER_REVIEWERS_LIST_ERROR:
            return {
                ...state,               
                filterFeedbackStatus: response.status,  
                filterFeedbackActivity:types.FEEDBACK_FILTER_REVIEWERS_LIST_ERROR+timeVar, 
                filterFeedbackErrorData:response.data                              
            };
        
        case types.CHIEF_REVIEWERS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    filterChiefReviewersList: response.data, 
                    filterFeedbackStatus: response.status,  
                    filterFeedbackActivity:types.CHIEF_REVIEWERS_LIST_SUCCESS+timeVar,  
                };
            }
            else {
                return {
                    filterFeedbackStatus: response.status,  
                    filterFeedbackActivity:types.CHIEF_REVIEWERS_LIST_ERROR+timeVar, 
                    filterFeedbackErrorData:response.data                           
                };
            }  
        case types.CHIEF_REVIEWERS_LIST_ERROR: 
            return {
                filterFeedbackStatus: response.status,  
                filterFeedbackActivity:types.CHIEF_REVIEWERS_LIST_ERROR+timeVar, 
                filterFeedbackErrorData:response.data                              
            };

        case types.CLEAR:
        return {
            ...state,
            filterFeedbackStatus:0,
            filterFeedbackActivity:types.CLEAR,
        } 
       
        default:
            return state;

    }
}

